import * as React from 'react';

import { Typography } from '../typography/typography';
import { cn } from '../../utils';

const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      className={cn(
        'rounded-xl bg-background text-default shadow-sm shadow-border-default',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Card.displayName = 'Card';

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div className={cn('flex items-center p-4', className)} ref={ref} {...props} />
  ),
);
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef<typeof Typography, React.HTMLAttributes<typeof Typography>>(
  ({ children, ...props }, _) => (
    <Typography variant="h200" element="h2" {...props}>
      {children}
    </Typography>
  ),
);
CardTitle.displayName = 'CardTitle';

const CardAction = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div className={cn('ml-auto', className)} ref={ref} {...props} />
  ),
);
CardAction.displayName = 'CardAction';

const CardContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div className={cn('p-4 pt-0', className)} ref={ref} {...props} />
  ),
);
CardContent.displayName = 'CardContent';

const CardFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      className={cn('flex items-center gap-4 justify-between p-4 pt-0', className)}
      ref={ref}
      {...props}
    />
  ),
);
CardFooter.displayName = 'CardFooter';

export { CardContent, CardHeader, CardFooter, CardAction, CardTitle, Card };
